import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import {
  BlockedRetailerModal,
  ExtensionLoadingModal,
  HeaderArea,
  LoadingCartFullPage,
  ReceiveBody,
  ReceiveHeader,
  RedirectionTakingTooLongModal,
  ReceiveUnsupportedModal,
} from 'src/components';
import {
  useGetCartQuery,
  useRedirectToUpperCase,
  useScrollToTop,
  useReceiveLogic,
  useVendorDeals,
} from 'src/hooks';
import { getCartIdAtom } from 'src/store';

export const Receive = () => {
  const [cartId, setCartId] = useAtom(getCartIdAtom);

  const { cartId: cartIdParam } = useParams();
  const navigate = useNavigate();

  // TODO: move cart id logic to hook.
  const cartQuery = useGetCartQuery({ cartId: cartIdParam ?? '' });
  useVendorDeals({ cartId: cartIdParam });

  // initialize the receive logic
  useReceiveLogic();

  useScrollToTop();
  useRedirectToUpperCase({
    cartIdParam,
    setCartId,
    pathname: 'receive',
  });

  useEffect(() => {
    if (!cartIdParam) {
      navigate('/get');
    } else {
      setCartId(cartIdParam);
    }
  }, [cartIdParam, navigate, setCartId]);

  if (cartQuery.isLoading) {
    return <LoadingCartFullPage />;
  }

  return (
    <>
      <HeaderArea>
        <ReceiveHeader />
      </HeaderArea>
      <ReceiveBody
        cartItems={cartQuery.data?.items || []}
        cartCCY={cartQuery.data?.cartCCY || ''}
        cartCCYS={cartQuery.data?.cartCCYS || ''}
        cartVendor={cartQuery.data?.vendor || ''}
        cartLocale={cartQuery.data?.locale}
        cartTimestamp={cartQuery.data?.timestamp || 0}
        cartTotalPrice={cartQuery.data?.formattedCartTotalPrice || ''}
        cartStore={cartQuery.data?.store || ''}
      />

      <ExtensionLoadingModal />

      {cartQuery.data && <BlockedRetailerModal cart={cartQuery.data} />}

      <RedirectionTakingTooLongModal cartId={cartId} />

      <ReceiveUnsupportedModal />
    </>
  );
};
